import StoreList from './List/StoreList';

export const Stores = () => <StoreList />;

export default Stores;
